export default "__VITE_ASSET__e5854c82__"